module.exports = __webpack_public_path__ + "static/media/sup.d79f912d.png";